import { lazy } from "react";

/**
 * Lazy-loaded page components
 */

export const HomePage = lazy(() =>
  import("../pages/homePage").then((m) => ({ default: m.HomePage })),
);

export const ContentPage = lazy(() =>
  import("../pages/contentPage").then((m) => ({ default: m.ContentPage })),
);

export const SignInPage = lazy(() =>
  import("../pages/signInPage").then((m) => ({ default: m.SignInPage })),
);

export const SignUpPage = lazy(() =>
  import("../pages/signUpPage").then((m) => ({ default: m.SignUpPage })),
);

export const AdvancedSearchPage = lazy(() =>
  import("../pages/advancedSearchPage").then((m) => ({
    default: m.AdvancedSearchPage,
  })),
);

export const CollectionPage = lazy(() =>
  import("../pages/collectionPage").then((m) => ({
    default: m.CollectionPage,
  })),
);

export const UserReviewsPage = lazy(() =>
  import("../pages/userReviewsPage").then((m) => ({
    default: m.UserReviewsPage,
  })),
);

export const UserFavoritesPage = lazy(() =>
  import("../pages/userFavoritesPage").then((m) => ({
    default: m.UserFavoritesPage,
  })),
);

export const UserCollectionsPage = lazy(() =>
  import("../pages/userCollectionsPage").then((m) => ({
    default: m.UserCollectionsPage,
  })),
);

export const UserHistoryPage = lazy(() =>
  import("../pages/userHistoryPage").then((m) => ({
    default: m.UserHistoryPage,
  })),
);

export const UserFollowsPage = lazy(() =>
  import("../pages/userFollowsPage").then((m) => ({
    default: m.UserFollowsPage,
  })),
);

export const ContentReviewPage = lazy(() =>
  import("../pages/").then((m) => ({ default: m.ContentReviewPage })),
);

export const ContentReviewListPage = lazy(() =>
  import("../pages/contentReviewListPage").then((m) => ({
    default: m.ContentReviewListPage,
  })),
);

export const CollectionsListPage = lazy(() =>
  import("../pages/collectionListPage").then((m) => ({
    default: m.CollectionListPage,
  })),
);

export const SettingsPage = lazy(() =>
  import("../pages/settingsPage").then((m) => ({ default: m.SettingsPage })),
);

export const AboutPage = lazy(() =>
  import("../pages/aboutPage").then((m) => ({ default: m.AboutPage })),
);

export const NotFoundPage = lazy(() =>
  import("../pages/notFoundPage").then((m) => ({ default: m.NotFoundPage })),
);

export const UserPage = lazy(() =>
  import("../pages/userPage").then((m) => ({ default: m.UserPage })),
);

export const PersonPage = lazy(() =>
  import("../pages/personPage").then((m) => ({ default: m.PersonPage })),
);

export const ContentDetailsPage = lazy(() =>
  import("../pages/contentDetailsPage").then((m) => ({
    default: m.ContentDetailsPage,
  })),
);
